export function groupSparksBySkill(
  sparks: SparkEntity[] | undefined,
  skills: { [key: string]: SkillEntity } | undefined,
  reflections?: ReflectionEntity[] | undefined
): { [key: string]: { name: string; sparks: SparkEntity[] } } {
  const groupedSparksObj: {
    [key: string]: { name: string; sparks: SparkEntity[] };
  } = {};

  if (!sparks || !skills) {
    return groupedSparksObj;
  }

  const sparksAttachedToProjectIds: Number[] = sparks.map((spark) => spark.id);
  const sparksAttachedToReflectionsIds: Number[] = [];
  const sparksAttachedToReflections: SparkEntity[] = [];

  if (reflections) {
    reflections.forEach((reflection) => {
      reflection.sparks.forEach((spark) => {
        if (!sparksAttachedToReflectionsIds.includes(spark.id)) {
          sparksAttachedToReflectionsIds.push(spark.id);
          sparksAttachedToReflections.push(spark);
        }
      });
    });
  }

  sparks.forEach((spark) => {
    const skillId = spark.skill_id;
    const skill = skills[skillId];

    if (skill) {
      if (!groupedSparksObj[skillId]) {
        groupedSparksObj[skillId] = {
          name: skill.name,
          sparks: [],
        };
      }

      if (sparksAttachedToReflectionsIds.includes(spark.id)) {
        spark.done = true;
      }

      groupedSparksObj[skillId].sparks.push(spark);
    }
  });

  sparksAttachedToReflections.forEach((spark) => {
    if (sparksAttachedToProjectIds.includes(spark.id)) {
      return;
    }
    const skillId = spark.skill_id;
    const skill = skills[skillId];

    if (skill) {
      if (!groupedSparksObj[skillId]) {
        groupedSparksObj[skillId] = {
          name: skill.name,
          sparks: [],
        };
      }
      spark.notInGoals = true;
      spark.done = true;
      groupedSparksObj[skillId].sparks.push(spark);
    }
  });

  return groupedSparksObj;
}
